import { get } from './https';

/**
 * Quote-request enquiries created by the user app via POST /user/enquiry/create
 * (subTypes: AMC, SELL_OLD_EQUIPMENT / OLD_BOILER, EXPERT_ADVICE, SITE_VISIT).
 * Same backend endpoint the Sell Old AC page uses; `types` is passed straight
 * to /admin/enquiry-list?type= and may be comma-separated.
 */
export const GetQuoteRequests = async ({
  types,
  page = 1,
  limit = 10,
  searchQuery = '',
}: {
  types: string;
  page?: number;
  limit?: number;
  searchQuery?: string;
}) => {
  let url = `/api/v1/admin/enquiry-list?limit=${limit}&page=${page}&type=${types}`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch quote requests');
  }
};

// Detail / assign reuse the generic enquiry endpoints already wrapped in
// services/sellOldAC.ts (EnquiryDetail, AssignInspector).
export { EnquiryDetail, AssignInspector } from './sellOldAC';
